<template>
    <div class="row">
        <div class="col-sm-12">
            <form autocomplete="off" method="post" data-vv-scope="form" @submit.prevent="onBeforeSaveItem(fallback)">
                <div class="row mb-3">
                    <div class="col-sm-auto">
                        <h1 class="content-title">{{ title }}</h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-appId"
                                name="appId"
                                label="name"
                                :filterable="true"
                                :options="lists.apps"
                                v-model.trim="form.appId"
                                :reduce="option => option.name"
                                @input="onChangeAppID"
                                v-validate="'required'"
                                :inputClasses="[{'is-invalid': fnHasError('appId') }]"
                                :error="fnFirstError('appId')">
                                {{ $t(`${configId}.model.appid`) }}
                            </MaterialSelect>
                        </div>
                    </div>
                    <div class="col-sm-4" v-if="showLayout">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-layout"
                                name="layout"
                                label="name"
                                :filterable="true"
                                :options="lists.layouts"
                                v-model.trim="form.layout"
                                :reduce="option => option.name"
                                v-validate="'required'"
                                :inputClasses="[{'is-invalid': fnHasError('layout') }]"
                                :error="fnFirstError('layout')">
                                {{ $t(`${configId}.model.layout`) }}
                            </MaterialSelect>
                        </div>
                    </div>
                    <div class="col-sm-4" v-if="showFormat">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-format"
                                name="format"
                                label="name"
                                :filterable="true"
                                :options="lists.formats"
                                v-model.trim="form.format"
                                :reduceObject="true"
                                v-validate="'required'"
                                :inputClasses="[{'is-invalid': fnHasError('format') }]"
                                :error="fnFirstError('format')">
                                {{ $t(`${configId}.model.format`) }}
                            </MaterialSelect>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <MaterialInput
                            :readonly="readonlyFormItem"
                            :disabled="readonlyFormItem"
                            type="text"
                            class="city-form-group city-bg"
                            id="input-municipality"
                            name="municipality"
                            v-model.trim="form.municipality"
                            v-validate="{required: false, 'min':3}"
                            :inputClasses="[{'is-invalid': fnHasError('municipality') }]"
                            :error="fnFirstError('municipality')" >
                            {{ $t(`${configId}.model.municipality`) }}
                        </MaterialInput>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                :disabled="readonlyFormItem"
                                type="text"
                                class="city-form-group city-bg"
                                id="input-title"
                                name="title"
                                v-model.trim="form.title"
                                v-validate="{required: form.cover_page_status == 1, 'min':3}"
                                :inputClasses="[{'is-invalid': fnHasError('title') }]"
                                :error="fnFirstError('title')" >
                                {{ $t(`${configId}.model.title`) }}
                            </MaterialInput>
                        </div>
                    </div>
                </div>
                <div class="mt-3" v-if="globalDoc">
                    <h6>{{ $t(`${configId}.global.title`) }}</h6>
                    <hr class="mt-2" />
                    <div class="row">
                        <div class="col-sm-3">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-global-status"
                                name="global-status"
                                label="name"
                                :filterable="true"
                                :options="lists.onoff"
                                v-model.trim="form.global_doc.status"
                                :reduce="option => option.code"
                                v-validate="'required'"
                                :inputClasses="[{'is-invalid': fnHasError('global-status') }]"
                                :error="fnFirstError('global-status')"
                                :helpText="helpGlobal.status">
                                {{ $t(`${configId}.global.model.status`) }}
                            </MaterialSelect>
                        </div>
                        <div class="col-sm-3">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-global-cover_page"
                                name="global-cover_page"
                                label="name"
                                :filterable="true"
                                :options="lists.onoff"
                                v-model.trim="form.global_doc.cover_page"
                                :reduce="option => option.code"
                                v-validate="'required'"
                                :inputClasses="[{'is-invalid': fnHasError('global-cover_page') }]"
                                :error="fnFirstError('global-cover_page')"
                                :helpText="helpGlobal.cover_page">
                                {{ $t(`${configId}.global.model.cover_page`) }}
                            </MaterialSelect>
                        </div>
                        <div class="col-sm-6">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                :disabled="readonlyFormItem"
                                type="text"
                                class="city-form-group city-bg"
                                id="input-global-pagination"
                                name="global-pagination"
                                v-model.trim="form.global_doc.pagination"
                                v-validate="''"
                                :inputClasses="[{'is-invalid': fnHasError('global-pagination') }]"
                                :error="fnFirstError('global-pagination')"
                                :helpText="helpGlobal.pagination">
                                {{ $t(`${configId}.global.model.pagination`) }}
                            </MaterialInput>
                        </div>
                    </div>
                </div>

                <slot name="report"
                    :form="form.report"
                    :readonlyFormItem="readonlyFormItem"
                    :onInput="onReportInput">
                    <ConfigReportGeneral
                        v-if="report"
                        class="mt-3"
                        :configId="configId"
                        :disabled="readonlyFormItem"
                        :reportLabel="reportLabel"
                        :reportHelp="reportHelp"
                        vScope="form"
                        v-model="form.report">
                    </ConfigReportGeneral>
                </slot>

                <div class="mt-3" v-if="showZoomToFeatures">
                    <h6>{{ $t(`${configId}.zoom.title`) }}</h6>
                    <hr class="mt-2" />
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <MaterialSelect
                                    :disabled="readonlyFormItem"
                                    class="city-form-group city-bg"
                                    id="input-zoomtype"
                                    name="zoomtype"
                                    label="name"
                                    :filterable="true"
                                    :options="lists.zoomtype"
                                    v-model.trim="form.zoom_to_features.zoomtype"
                                    :reduce="option => option.code"
                                    v-validate="'required'"
                                    :inputClasses="[{'is-invalid': fnHasError('zoomtype') }]"
                                    :error="fnFirstError('zoomtype')">
                                    {{ $t(`${configId}.zoom.model.zoomtype`) }}
                                </MaterialSelect>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyFormItem"
                                    :disabled="readonlyFormItem"
                                    type="number"
                                    class="city-form-group city-bg"
                                    id="input-minmargin"
                                    name="minmargin"
                                    v-model.trim="form.zoom_to_features.minmargin"
                                    v-validate="'required|integer'"
                                    :inputClasses="[{'is-invalid': fnHasError('minmargin') }]"
                                    :error="fnFirstError('minmargin')" >
                                    {{ $t(`${configId}.zoom.model.minmargin`) }}
                                </MaterialInput>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyFormItem"
                                    :disabled="readonlyFormItem"
                                    type="text"
                                    class="city-form-group city-bg"
                                    id="input-minscale"
                                    name="minscale"
                                    v-model.trim="form.zoom_to_features.minscale"
                                    v-validate="'required|decimal:3'"
                                    :inputClasses="[{'is-invalid': fnHasError('minscale') }]"
                                    :error="fnFirstError('minscale')" >
                                    {{ $t(`${configId}.zoom.model.minscale`) }}
                                </MaterialInput>
                            </div>
                        </div>
                    </div>
                </div>

                <ConfigDrawGeneral
                    v-if="draw"
                    class="mt-3"
                    :configId="configId"
                    :disabled="readonlyFormItem"
                    vScope="form"
                    v-model="form.draw">
                </ConfigDrawGeneral>

                <slot name="featureable"
                    :form="form.featureable"
                    :readonlyFormItem="readonlyFormItem"
                    :onInput="onFeatureableInput">
                    <ConfigFeatureableGeneral
                        v-if="featureable"
                        class="mt-3"
                        :configId="configId"
                        :disabled="readonlyFormItem || !form.draw.status"
                        :featureableHelp="featureableHelp"
                        vScope="form"
                        v-model="form.featureable">
                    </ConfigFeatureableGeneral>
                </slot>

                <slot name="upload"
                    :form="form.upload"
                    :readonlyFormItem="readonlyFormItem"
                    :onInput="onUploadInput">
                    <ConfigUploadGeneral
                        v-if="upload"
                        class="mt-3"
                        :configId="configId"
                        :uploadHelp="uploadHelp"
                        :disabled="readonlyFormItem"
                        vScope="form"
                        v-model="form.upload">
                    </ConfigUploadGeneral>
                </slot>

                <slot name="notifications"
                    :form="form.notifications"
                    :readonlyFormItem="readonlyFormItem"
                    :onInput="onNotificationsInput">
                    <ConfigNotificationsGeneral
                        v-if="notifications"
                        class="mt-3"
                        :configId="configId"
                        :uploadHelp="notificationsHelp"
                        :disabled="readonlyFormItem"
                        vScope="form"
                        v-model="form.notifications">
                    </ConfigNotificationsGeneral>
                </slot>

                <div class="row mt-3">
                    <div class="col photos">
                        <div class="row">
                            <div class="col">
                                <h6 class="font-weight-normal">{{ $t(`${configId}.model.logo`) }}</h6>
                                <hr class="mt-2" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-sm-12">
                                <div class="photo mb-3 mb-sm-4">
                                    <UploadSingleImage
                                        v-model="form.logo_path"
                                        :noOverlay="true"
                                        name="logo_path"
                                        :disabled="readonlyFormItem"
                                        v-validate="''"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <buttons-footer
                    :enableButtons="!readonlyFormItem"
                    :cancelTitle="cancelTitle"
                    :submitTitle="submitTitle"
                    :isDisabled="isDisabled"
                    :showCancelButton="!!fallback"
                    @save="onBeforeSaveItem(fallback)"
                    @cancel="handleBack(fallbackCancel, !!fallbackCancel)"/>
            </form>
        </div>
    </div>
</template>

<script>
import BaseModuleMixin from '@/app/shared/mixins/BaseModuleMixin';
import BaseGestaoMixin from '@/app/shared/mixins/BaseGestaoMixin';

export default {
    mixins: [
        BaseModuleMixin,
        BaseGestaoMixin
    ],
    components: {
        UploadMultipleImage: () => import(/* webpackChunkName: "upload-multiple-image" */ '@/components/form/UploadMultipleImage'),
        UploadSingleImage: () => import(/* webpackChunkName: "upload-single-image" */ '@/components/form/UploadSingleImage'),
        ConfigReportGeneral: () => import(/* webpackChunkName: "config-report-general" */ './report/ConfigReportGeneral'),
        ConfigDrawGeneral: () => import(/* webpackChunkName: "config-draw-general" */ './draw/ConfigDrawGeneral'),
        ConfigFeatureableGeneral: () => import(/* webpackChunkName: "config-featureable-general" */ './featureable/ConfigFeatureableGeneral'),
        ConfigUploadGeneral: () => import(/* webpackChunkName: "config-upload-general" */ './upload/ConfigUploadGeneral'),
        ConfigNotificationsGeneral: () => import(/* webpackChunkName: "config-notifications-general" */ './notifications/ConfigNotificationsGeneral'),
    },
    provide () {
        return { parentValidator: this.$validator }
    },
    props: {
        internalCode: {
            type: String,
            require: true,
        },
        panelID: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: ''
        },
        globalDoc: {
            type: Boolean,
            default: false
        },
        globalDocHelp: {
            type: Object,
        },
        draw: {
            type: Boolean,
            default: true
        },
        upload: {
            type: Boolean,
            default: false
        },
        uploadHelp: {
            type: Object,
        },
        notificationsHelp: {
            type: Object,
        },
        report: {
            type: Boolean,
            default: false
        },
        reportLabel: {
            type: String,
            default: null
        },
        reportHelp: {
            type: String,
            default: 'Incluir relatório de cruzamento'
        },
        showZoomToFeatures: {
            type: Boolean,
            default: true
        },
        showLayout: {
            type: Boolean,
            default: true
        },
        showFormat: {
            type: Boolean,
            default: true
        },
        forceFallback: {
            type: Boolean,
            default: true
        },
        components: {
            type: Array,
            default: () => []
        },
        defaultLayout: {
            type: String,
            default: 'A4 portrait',
        },
        featureable: {
            type: Boolean,
            default: false
        },
        featureableHelp: {
            type: Object,
        },
        notifications: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            configId: 'print_manage',
            lists: {
                loaded: false,
                onoff: [{'id': 1, 'name': 'Sim', 'code': 1}, {'id': 2, 'name': 'Não', 'code': 0}],
                zoomtype: [{'id': 1, 'name': 'Extent', 'code': 'extent'}, {'id': 2, 'name': 'Center', 'code': 'center'}],
                layouts: [],
                formats: [],
                apps: [],
            },
            form: {
                id: null,
                appId: null,
                title: null,
                municipality: null,
                logo_path: null,
                layout: null,
                format: null,
                draw: {
                    status: 0,
                },
                report: {
                    status: 0,
                },
                zoom_to_features: {
                    zoomtype: null,
                    minscale: null,
                    minmargin: null,
                    // layer: null,
                },
                upload: {
                    status: 0,
                },
                featureable: {
                    status: 0,
                },
                notifications: {
                    status: 0,
                    channel: 'mail',
                },
                global_doc: {
                    status: 1,
                    cover_page: 1,
                    pagination: null,
                },
            },

        }
    },
    mounted() {
        this.pageID = this.panelID;
        this.loadItem(this.url.getConfig, false)
        .then( res => {
            if(res) {
                this.loadLists();
            }
        });
    },
    computed: {
        moduleInternalCode() {
            return this.internalCode;
        },
        fallback() {
            return this.forceFallback ? `${this.moduleInternalCode}.${this.pageID}` : `${this.moduleInternalCode}.${this.pageID}.config`
        },
        fallbackCancel() {
            return this.forceFallback ? `${this.moduleInternalCode}.${this.pageID}` :''
        },
        readonlyFormItem() {
            return !this.canConfigEdit;
        },
        helpGlobal() {
            return this.globalDocHelp ?? this.$t(`${this.configId}.global.help`);
        }
    },
    methods: {
        loadLists: function() {
            if (this.canConfigEdit && !this.lists.loaded) {
                this.$http.get(this.url.getApps)
                .then(res => {
                    this.lists.apps = res.data.data.sort().map(x => {return {name: x};});
                    this.loadSubLists();
                })
                .catch(error => {
                    this.lists.loaded = false;
                    this.showHttpError(error);
                });
            }
        },
        // forceDirtyLogo: function(){
        //     if(this.fields.$form && this.fields.$form['logo_path']){
        //         this.fields.$form['logo_path'].dirty=true;
        //     }
        // },
        onBeforeSaveItem(fallback) {
            if(this.canConfigEdit) {
                this.saveItem(fallback, [], {}, true);
            }
        },
        onChangeAppID: function() {
            if (this.canConfigEdit) {
                this.resetLayout().then(res => {
                    this.setFieldDirty('appId');
                    this.loadSubLists();
                    if(!this.showLayout){
                        this.form.layout = this.lists.layouts.length ? this.lists.layouts[0] : this.defaultLayout;
                    }
                });
            }
        },
        async resetLayout() {
            this.lists.layouts = [];
            this.form.layout = null;
            this.lists.formats = [];
            this.form.format = null;
            await this.resetValidator();
        },
        loadSubLists() {
            if(this.showLayout){
                this.$http.get(this.url.getLayouts.replace(':appid', this.form.appId))
                .then(res => {
                    this.lists.layouts = res.data.data;
                })
                .catch(error => {
                    this.lists.loaded = false;
                    this.showHttpError(error);
                });
            }
            if(this.showFormat) {
                this.$http.get(this.url.getFormats.replace(':appid', this.form.appId))
                .then(res => {
                    this.lists.formats = res.data.data;
                })
                .catch(error => {
                    this.lists.loaded = false;
                    this.showHttpError(error);
                });
            }
        },
        onReportInput(val) {
            this.form.report = val;
        },
        onUploadInput(val) {
            this.form.upload = val;
        },
        onFeatureableInput(val) {
            this.form.featureable = val;
        },
        onNotificationsInput(val) {
            this.form.notifications = val;
        },
    },
}
</script>

<style scoped lang="scss">
@import "@styles/_mixins.scss";
.photos {
    .photo {
        height: 100%;
        min-height: 100px;
        max-width: 100%;

        @include sm {
            max-width: 100%;
            min-height: 150px;
        }
    }
}
</style>
